document.addEventListener("DOMContentLoaded", () => {
  // All product forms that post to /cart/add
  const forms = document.querySelectorAll('form[action="/cart/add"]');

  // ---- Helpers -------------------------------------------------------

  // Collect selected add-on items from checkboxes
  function getAddonItems() {
    const addonCheckboxes = document.querySelectorAll(".addon-checkbox:checked");
    const items = [];

    addonCheckboxes.forEach((cb) => {
      items.push({
        id: cb.dataset.variantId,
        quantity: 1,
      });
    });

    return items;
  }

  // Get main product (variant + qty) from a given form
  function getMainItemFromForm(form) {
    if (!form) return null;

    const variantInput = form.querySelector("[name='id']");
    if (!variantInput) return null;

    const qtyInput = form.querySelector("[name='quantity']");
    const qtyRaw = qtyInput && qtyInput.value ? qtyInput.value : "1";
    const qty = parseInt(qtyRaw, 10) || 1;

    return {
      id: variantInput.value,
      quantity: qty,
    };
  }

  // Fire Horizon's cart drawer event to open/refresh side drawer
  function openCartDrawer() {
    try {
      document.dispatchEvent(
        new CustomEvent("cart:update", {
          bubbles: true,
          detail: {
            data: {
              itemCount: 1,
              source: "product-form-component",
            },
          },
        })
      );
    } catch (e) {
      console.warn("cart:update dispatch failed", e);
    }
  }

  // Shared add flow:
  //  - items: [{id, quantity}, ...]
  //  - options: { redirect: '/cart' | '/checkout' | null, openDrawer: boolean }
  function addItems(items, options = {}) {
    if (!items || !items.length) return;

    const { redirect = null, openDrawer = false } = options;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items }),
    })
      .then((res) => res.json())
      .then(() => {
        if (openDrawer) {
          openCartDrawer();
        }
        if (redirect) {
          window.location.href = redirect;
        }
      })
      .catch((error) => {
        console.error("Error adding items:", error);
        if (redirect) {
          window.location.href = redirect;
        }
      });
  }

  // ---- Main Add to Cart + Buy It Now (inside forms) ------------------

  if (forms.length) {
    forms.forEach((form) => {
      // Main Add to Cart button inside the form
      const addToCartButton =
        form.querySelector('button[type="submit"][name="add"]') ||
        form.querySelector('button[type="submit"]') ||
        form.querySelector('input[type="submit"][name="add"]') ||
        form.querySelector('input[type="submit"]');

      if (addToCartButton) {
        // Use capture so we run before theme's handler
        addToCartButton.addEventListener(
          "click",
          (event) => {
            const addonItems = getAddonItems();
            if (!addonItems.length) {
              // No add-ons selected → let theme JS handle normal add-to-cart + drawer
              return;
            }

            // Prevent handling synthetic clicks (e.g. triggered by sticky bar script)
            if (!event.isTrusted) {
              return;
            }

            // Stop theme's own Add to Cart logic (we'll add everything ourselves)
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            const mainItem = getMainItemFromForm(form);
            if (!mainItem) {
              form.submit();
              return;
            }

            const items = [mainItem, ...addonItems];

            // Add everything via AJAX, then open Horizon cart drawer (no redirect)
            addItems(items, { openDrawer: true });
          },
          { capture: true }
        );
      }

      // Dynamic Buy It Now / payment button
      const buyNowButton =
        form.querySelector(".shopify-payment-button__button") ||
        form.querySelector(".shopify-payment-button__button--unbranded");

      if (buyNowButton) {
        buyNowButton.addEventListener(
          "click",
          (event) => {
            const addonItems = getAddonItems();
            if (!addonItems.length) {
              // No add-ons → let native express checkout work normally
              return;
            }

            // Stop Shopify's native Buy It Now handler
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            const mainItem = getMainItemFromForm(form);
            if (!mainItem) {
              form.submit();
              return;
            }

            const items = [mainItem, ...addonItems];

            // Add everything, then go to regular checkout
            addItems(items, { redirect: "/checkout" });
          },
          { capture: true }
        );
      }
    });
  }

  // NOTE: We do NOT attach any handler to the sticky add to cart button.
  // It will always use the theme's default behavior and only add the main product.
});
